<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M55 11v42a2 2 0 01-2 2H40.74V37.19h6l.9-6.94h-6.9v-4.44a3.83 3.83 0 01.71-2.51 3.49 3.49 0 012.74-.84h3.65v-6.2a40 40 0 00-5.33-.26A8.88 8.88 0 0036 18.36a9 9 0 00-2.44 6.76v5.13h-6v6.94h6V55H11a2 2 0 01-2-2V11a2 2 0 012-2h42a2 2 0 012 2z"/></svg>